import request from '@/utils/request'

/**
 * 查询所有角色
 * @param query
 */
export function fetchAll(query) {
	return request({
		url: '/api/role/all',
		method: 'get',
		data: query
	})
}

/**
 * 查询角色列表
 * @param query
 */
export function fetchList(query) {
	return request({
		url: '/api/role/list',
		method: 'post',
		data: query
	})
}

/**
 * 保存角色
 * @param param
 */
export function save(param) {
	return request({
		url: '/api/role/save',
		method: 'post',
		data: param
	})
}

/**
 * 修改角色
 * @param param
 */
export function update(param) {
	return request({
		url: '/api/role/update',
		method: 'post',
		data: param
	})
}

/**
 * 删除角色
 * @param param
 */
export function remove(param) {
	return request({
		url: '/api/role/delete/' + param,
		method: 'post'
	})
}

/**
 * 获取单个角色信息
 * @param param
 */
export function get(param) {
	return request({
		url: '/api/role/view/' + param,
		method: 'get'
	})
}

/**
 * 为角色分配资源
 * @param roleId
 * @param param
 */
export function allot(roleId, perms) {
	return request({
		url: '/api/role/allot/resource/' + roleId,
		method: 'post',
		data: perms
	})
}

/**
 * 查询角色分配资源id
 * @param roleId
 */
export function fetchResIds(roleId) {
	return request({
		url: '/api/role/fetch/resource/' + roleId,
		method: 'get'
	})
}
